/**
 * Authentication context definition.
 */

import { createContext } from 'react';
import type { AuthContextValue } from './types';

/**
 * React context for authentication state.
 */
export const AuthContext = createContext<AuthContextValue | null>(null);
